import React, { useEffect, useState } from "react";
import "../../Pages/CleeQ.css";
import "../../Pages/Responsive.css";
import { makeStyles } from "@material-ui/core/styles";
import Aos from "aos";
import "aos/dist/aos.css";
import ContactUs from "../ContactUs";
import "../../Components/NavBar/NavBar.css";
import NavBar from "../../Components/NavBar/NavBar";
import SocialHeadings from "../../Components/SocialHeadings";
import BBQParty2022 from "./BBQParty2022";
import EventProperties from "./EventProperties";

// const NavBar = () => {
//   return (
//     <div className="container NavBarContainer p-0">
//       <div>
//         <SoleraLogo />
//       </div>
//       <div>
//       <NavBarList/>
//       </div>

//       <div className="SignUpAndLoginContianer22">
//         <SignUpAndLogin />
//       </div>
//     </div>
//   );
// };

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

function Events({ show, onClose, onOpen }) {
  const [eventDay1Show, setEventDay1Show] = useState(false);
  const handleEventDay1 = () => setEventDay1Show(false);

  useEffect(() => {
    Aos.init({ duration: 1000 });
    window.scrollTo(0, 0); // This will scroll the page to the top when the component mounts
  }, []);

  const classes = useStyles();

  return (
    <div>
      <header className="SoleraSticky">
        <div className="SocialHeadings-Display">
          <SocialHeadings />
        </div>
        <NavBar />
      </header>

      <div>
        <EventProperties />
      </div>

      <div id="Photo Gallery">
        <ContactUs />
      </div>
    </div>
  );
}

export default Events;
